import { Tooltip } from 'bootstrap';
import React, { createContext, useState, useEffect } from 'react';

export const TooltipContext = createContext();

export const TooltipProvider = ({ children }) => {
    const [tooltips, setTooltips] = useState({});

    useEffect(() => {
        fetch('/tooltips.json')
            .then((response) => response.json())
            .then((data) => {
                setTooltips(data);

                setTimeout(() => {
                    const tooltipTriggerList = Array.from(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
                    tooltipTriggerList.forEach((tooltipTriggerEl) => {
                        new Tooltip(tooltipTriggerEl);
                    });
                }, 500);
            });
    }, []);

    return (
        <TooltipContext.Provider value={tooltips}>
            {children}
        </TooltipContext.Provider>
    );
};